import styled from 'styled-components'

const StickyBottomArticle = styled.article`
bottom: 0;
position: sticky;
padding: 1rem !important;
`

export default StickyBottomArticle